import { propStyles } from 'src/utils/propStyles';
import { styled } from 'src/utils/styled';

const FilterDropdownInnerWrapper = styled<any, any>(
    'div',
    'filterDropdownInnerWrapper',
    'filterItemDropdown'
)`
    ${propStyles};
`;

FilterDropdownInnerWrapper.defaultProps = {
    position: 'relative',
    marginX: 'lg',
    marginY: 'sm',
};

export default FilterDropdownInnerWrapper;



// WEBPACK FOOTER //
// ./src/Components/Filters/Components/StyledComponents/FilterDropdownInnerWrapper.tsx